import gql from "graphql-tag";

export default gql`
  mutation UpdateUser(
    $Id: ID!
    $Usuario: String!
    $Pass: String!
    $admin: Int!
    $nombre: String!
    $email: String!
    $limitar: String!
    $descmax: Int!
  ) {
    updateUser(
      input: {
        Id: $Id
        Usuario: $Usuario
        Pass: $Pass
        admin: $admin
        nombre: $nombre
        email: $email
        limitar: $limitar
        descmax: $descmax
      }
    ) {
      Id
      Usuario
      admin 
      nombre
      email
      limitar
      descmax

    }
  }
`;
